module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vc-parallax', {
    attrs: {
      "nav-color": _vm.configurator.navColor.model,
      "nav-type": _vm.configurator.navType.model,
      "nav-accent-color": _vm.configurator.navAccentColor.model,
      "nav-position": _vm.configurator.navPosition.model
    },
    on: {
      "before-destroy": _vm.onBeforeDestroy,
      "mounted": _vm.onMounted,
      "section-change": _vm.onSectionChange
    }
  }, [_c('vc-parallax-section', {
    attrs: {
      "color": _vm.configurator.sectionColor.model,
      "backdrop": "/docs/images/section-01.jpg"
    }
  }, [_c('info-block', [_c('h1', [_vm._v("Parallax for VueJs")]), _vm._v(" "), _c('p', [_vm._v("VcParallax is a lightweight component, based on "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("VueJs")]), _vm._v(" for adding awesome parallax effects to web pages.\n            Use the controls on the right to navigate to the "), _c('a', {
    attrs: {
      "href": "##"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateToSectionByIndex(1)
      }
    }
  }, [_vm._v("next slide")]), _vm._v(" to learn how to get started...")])])], 1), _vm._v(" "), _c('vc-parallax-section', {
    attrs: {
      "color": _vm.configurator.sectionColor.model,
      "bg-color": _vm.configurator.sectionBgColor.model
    }
  }, [_c('info-block', {
    attrs: {
      "title": "Get Started"
    }
  }, [_c('p', [_vm._v("The easiest way to start using VcParallax is to install it via NPM or Yarn:")]), _vm._v(" "), _c('code-block', [_vm._v("// npm\n$ npm install vc-parallax --save\n// yarn\n$ yarn add vc-parallax")]), _vm._v(" "), _c('p', [_vm._v("Adding to a Vue project:")]), _vm._v(" "), _c('code-block', [_vm._v("import {VcParallax, VcParallaxSection} from 'vc-parallax'\n// import the stylesheet\nimport '../node_modules/vc-parallax/dist/lib/vc-parallax.min.css'\n// add to Vue\nVue.use(VcParallax)\nVue.use(VcParallaxSection)")]), _vm._v(" "), _c('p', [_vm._v("Then proceed to the "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateToSectionByIndex(2)
      }
    }
  }, [_vm._v("configuration options")]), _vm._v(".\n            Also, don't forget to check the "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateToSectionByIndex(3)
      }
    }
  }, [_vm._v("events")]), _vm._v(" emitted\n            by the component and readme file for a complete overview of the component.")])], 1)], 1), _vm._v(" "), _c('vc-parallax-section', {
    attrs: {
      "color": _vm.configurator.sectionColor.model,
      "backdrop": "/docs/images/section-02.jpg"
    }
  }, [_c('info-block', {
    attrs: {
      "title": "Configurator"
    }
  }, [_c('controls-list', {
    attrs: {
      "configurator": _vm.configurator
    }
  }), _vm._v(" "), _c('p', [_vm._v("* nav-accent-color: You need to select \"scroll\" nav-type in order for the changes to take effect")]), _vm._v(" "), _c('code-viewer', {
    attrs: {
      "configurator": _vm.configurator
    }
  }), _vm._v(" "), _c('p', [_vm._v("Done here? Check the component "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateToSectionByIndex(3)
      }
    }
  }, [_vm._v("events")]), _vm._v(".")])], 1)], 1), _vm._v(" "), _c('vc-parallax-section', {
    attrs: {
      "color": _vm.configurator.sectionColor.model,
      "bg-color": _vm.configurator.sectionBgColor.model
    }
  }, [_c('info-block', {
    attrs: {
      "title": "Component Events"
    }
  }, [_c('p', [_vm._v("The component emits the following custom events:")]), _vm._v(" "), _c('code-block', [_vm._v("@mounted\n@before-destroy\n@section-change")]), _vm._v(" "), _c('p', [_vm._v("Check browser's console for the data returned by these events. To control the component from the outside,\n            you can emit the "), _c('code', [_vm._v("navigate-to-section")]), _vm._v(" event to the "), _c('code', [_vm._v("$root")]), _vm._v(" of the app and pass the "), _c('code', [_vm._v("index")]), _vm._v(" of\n            the section that you want to show:")]), _vm._v(" "), _c('code-block', [_vm._v("/**\n  * Navigate to a parallax section by index\n  * @method navigateToSectionByIndex\n  * @param {number} index [index=0]\n  * @return {void}\n  */\n  navigateToSectionByIndex (index = 0) {\n  this.$root.$emit('navigate-to-section', index)\n}")]), _vm._v(" "), _c('p', [_vm._v("That's all! Follow me "), _c('a', {
    attrs: {
      "href": "https://twitter.com/vuecidity",
      "target": "_blank"
    }
  }, [_vm._v("@vuecidity")]), _vm._v(", check\n            "), _c('a', {
    attrs: {
      "href": "https://wemakesites.net",
      "target": "_blank"
    }
  }, [_vm._v("wemakesites.net")]), _vm._v(" or my\n            "), _c('a', {
    attrs: {
      "href": "https://martinivanov.net",
      "target": "_blank"
    }
  }, [_vm._v("blog")]), _vm._v(".")])], 1)], 1)], 1), _vm._v(" "), _c('social-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bdb4100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 46
// module chunks = 0